import {z} from "../../../lib";
import {schemaEntityListWithPagination, schemaEntityWithId, schemaEntityWithIdAndDescription} from "../../../types";
import {schemaMensaje} from "../../messages/types";

export enum DashboardMensajesPorEtapaEstadoFields {
  EtapaEstado = 'vchDescEtapaEstado',
  CantMensajes = 'intCantmensajes',
}

export const schemaDashboardAtrasoPorEtapa = z.object({
  [DashboardMensajesPorEtapaEstadoFields.EtapaEstado]: z.string(),
  [DashboardMensajesPorEtapaEstadoFields.CantMensajes]: z.number(),
}).merge(schemaEntityWithId)

export type DashboardMensajesPorEtapa = z.infer<typeof schemaDashboardAtrasoPorEtapa>

export enum DashboardAtrasoPorSistemaEtapaFields {
  Sistema = 'vchNombreSistema',
  Etapa = 'vchNombreEtapa',
  AtrasoTotalDias = 'decAtrasoTotalDias',
  AtrasoPromedioDias = 'decAtrasoPromedioDias',
  CantMensajes = 'intCantmensajes',
}

export const schemaDashboardAtrasoPorSistemaEtapa = z.object({
  [DashboardAtrasoPorSistemaEtapaFields.Sistema]: z.string(),
  [DashboardAtrasoPorSistemaEtapaFields.Etapa]: z.string(),
  [DashboardAtrasoPorSistemaEtapaFields.AtrasoTotalDias]: z.number(),
  [DashboardAtrasoPorSistemaEtapaFields.AtrasoPromedioDias]: z.number(),
  [DashboardAtrasoPorSistemaEtapaFields.CantMensajes]: z.number(),
}).merge(schemaEntityWithId)

export type DashboardAtrasoPorSistemaEtapa = z.infer<typeof schemaDashboardAtrasoPorSistemaEtapa>

export enum DashboardAtrasoPorSistemaFields {
  Sistema = 'vchNombreSistema',
  Abreviacion = 'vchDescSistemaTipoCorto',
  AtrasoTotalDias = 'decAtrasoTotalDias',
  AtrasoPromedioDias = 'decAtrasoPromedioDias',
  CantMensajes = 'intCantmensajes',
}

export const schemaDashboardAtrasoPorSistema = z.object({
  [DashboardAtrasoPorSistemaFields.Sistema]: z.string(),
  [DashboardAtrasoPorSistemaFields.Abreviacion]: z.string(),
  [DashboardAtrasoPorSistemaFields.AtrasoTotalDias]: z.number(),
  [DashboardAtrasoPorSistemaFields.AtrasoPromedioDias]: z.number(),
  [DashboardAtrasoPorSistemaFields.CantMensajes]: z.number(),
}).merge(schemaEntityWithId)

export type DashboardAtrasoPorSistema = z.infer<typeof schemaDashboardAtrasoPorSistema>

export enum DashboardPromedioResolucionFields {
  Sistema = 'vchNombreSistema',
  Abreviacion = 'vchDescSistemaTipoCorto',
  Etapa = 'vchNombreEtapa',
  AtrasoPromedioDias = 'decAtrasoPromedioDias',
  CantMensajes = 'intCantmensajesFinalizados',
}

export const schemaDashboardPromedioResolucion = z.object({
  [DashboardPromedioResolucionFields.Sistema]: z.string(),
  [DashboardPromedioResolucionFields.Abreviacion]: z.string(),
  [DashboardPromedioResolucionFields.Etapa]: z.string(),
  [DashboardPromedioResolucionFields.AtrasoPromedioDias]: z.number(),
  [DashboardPromedioResolucionFields.CantMensajes]: z.number(),
}).merge(schemaEntityWithId)

export type DashboardPromedioResolucion = z.infer<typeof schemaDashboardPromedioResolucion>

export enum DashboardMensajesPorPeriodoFields {
  Periodo = 'vchPeriodo',
  CantMensajes = 'intCantmensajes',
}

export const schemaDashboardMensajesPorPeriodo = z.object({
  [DashboardMensajesPorPeriodoFields.Periodo]: z.string(),
  [DashboardMensajesPorPeriodoFields.CantMensajes]: z.number(),
}).merge(schemaEntityWithId)

export type DashboardMensajesPorPeriodo = z.infer<typeof schemaDashboardMensajesPorPeriodo>

export enum DashboardFields {
  MensajesPorEtapaEstado = 'mensajesPorEtapaEstado',
  AtrasoPorSistemaEtapa = 'atrasoPorSistemaEtapa',
  AtrasoPorSistema = 'atrasoPorSistema',
  PromedioResolucion = 'promedioResolucion',
  MensajesPorPeriodo = 'mensajesPorPeriodo',
  Mensajes = 'mensajes',
}

export const schemaDashboard = z.object({
  [DashboardFields.MensajesPorEtapaEstado]: z.array(schemaDashboardAtrasoPorEtapa),
  [DashboardFields.AtrasoPorSistemaEtapa]: z.array(schemaDashboardAtrasoPorSistemaEtapa),
  [DashboardFields.AtrasoPorSistema]: z.array(schemaDashboardAtrasoPorSistema),
  [DashboardFields.PromedioResolucion]: z.array(schemaDashboardPromedioResolucion),
  [DashboardFields.MensajesPorPeriodo]: z.array(schemaDashboardMensajesPorPeriodo),
  [DashboardFields.Mensajes]: schemaEntityListWithPagination(schemaMensaje),
}).merge(schemaEntityWithId)

export type DashboardViewDTO = z.infer<typeof schemaDashboard>

export enum TipoTreshold {
  Atraso = 1,
  Resolucion = 2,
}

export enum DashboardTresholdsFields {
  TipoTreshold = 'tinCodTipoThreshold',
  Threshold = 'decThreshold',
  HexColor = 'vchHexColor',
  Orden = 'tinOrden',
}

export const schemaDashboardTresholds = z.object({
  [DashboardTresholdsFields.TipoTreshold]: z.number(),
  [DashboardTresholdsFields.Threshold]: z.number().nullable(),
  [DashboardTresholdsFields.HexColor]: z.string(),
  [DashboardTresholdsFields.Orden]: z.number(),
}).merge(schemaEntityWithIdAndDescription)

export type DashboardTresholds = z.infer<typeof schemaDashboardTresholds>